// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import bnr_logo from "../../assets/images/bnr_logo.png";

// const exportToPDF = (
//   pdfTitle,
//   userAccountInfo,
//   exchange,
//   date,
//   tableHeaders,
//   tableBody
// ) => {
//   const doc = new jsPDF();

//   const pageWidth = doc.internal.pageSize.width;
//   const pageHeight = doc.internal.pageSize.height;
//   const marginLeft = 5;
//   const marginRight = 5;
//   const marginTop = 70;
//   const marginBottom = 30;
//   const colWidth = (pageWidth - marginLeft - marginRight) / 2;

//   // Header Function
//   const header = () => {
//     doc.setFontSize(9);
//     doc.addImage(bnr_logo, "PNG", marginLeft, 10, 0, 15);
//     doc.setTextColor(81, 92, 101);
//     doc.text("6-3-652, 4TH FLOOR KAUTILYA AMRUTHA ESTATES,", marginLeft, 30);
//     doc.text(
//       "SOMAJIGUDA HYDERABAD-500082 Ph. No. :40527777-40727777,",
//       marginLeft,
//       35
//     );

//     doc.setFillColor(18, 97, 166);
//     doc.setTextColor(255, 255, 255);
//     doc.rect(marginLeft, 38, colWidth, 12, "F");
//     doc.setFont("helvetica", "bold"); // Set font to Helvetica Bold
//     doc.setFontSize(14);
//     doc.text(pdfTitle, marginLeft + 2, 45);

//     doc.setTextColor(81, 92, 101);
//     doc.setFontSize(9);
//     const pageCount = doc.internal.getNumberOfPages();
//     doc.text(`Page ${pageCount}`, pageWidth - marginRight - 15, 15);

//     doc.setFillColor(245, 246, 248);
//     doc.rect(
//       pageWidth - colWidth - marginRight + 10,
//       20,
//       colWidth - 10,
//       30,
//       "F"
//     );
//     doc.setTextColor(81, 92, 101);
//     doc.setFontSize(7);
//     doc.text(`Account Name:`, pageWidth - colWidth - marginRight + 15, 24);
//     doc.setFont("helvetica", "normal");
//     doc.text(
//       `${userAccountInfo?.name}`,
//       pageWidth - colWidth - marginRight + 34,
//       24
//     );
//     doc.setFont("helvetica", "bold");
//     doc.text(`Client ID:`, pageWidth - colWidth - marginRight + 15, 28);
//     doc.setFont("helvetica", "normal");
//     doc.text(
//       `${userAccountInfo?.trade?.client_id}`,
//       pageWidth - colWidth - marginRight + 27,
//       28
//     );
//     doc.setFont("helvetica", "bold");
//     doc.text(`Address:`, pageWidth - colWidth - marginRight + 15, 32);
//     doc.setFont("helvetica", "normal");
//     doc.text(
//       `${userAccountInfo?.personal_details?.address?.line_one}`,
//       pageWidth - colWidth - marginRight + 27,
//       32
//     );
//     doc.text(
//       `${userAccountInfo?.personal_details?.address?.line_two}`,
//       pageWidth - colWidth - marginRight + 27,
//       36
//     );
//     doc.text(
//       `${userAccountInfo?.personal_details?.address?.line_three}`,
//       pageWidth - colWidth - marginRight + 27,
//       40
//     );
//     doc.text(
//       `${userAccountInfo?.personal_details?.address?.line_four}`,
//       pageWidth - colWidth - marginRight + 27,
//       44
//     );
//     if(exchange && exchange?.trim()!==''){
//       doc.setFont("helvetica", "bold");
//       doc.text(`Exchange:`, pageWidth - colWidth - marginRight + 15, 48);
//       doc.setFont("helvetica", "normal");
//       doc.text(`${exchange}`, pageWidth - colWidth - marginRight + 28, 48);
//     }

//   };

//   // Footer Function
//   const footer = () => {
//     doc.setFontSize(9);
//     doc.setFont("helvetica", "normal");
//     doc.setTextColor(111, 121, 130);
//     doc.text(
//       "Your running account authorization would continue until it is revoked by you.",
//       marginLeft,
//       pageHeight - 25
//     );

//     doc.text(
//       "COMPLIANCE OFFICER DETAILS: G SABITHA REDDY, Phone No: 040-40526277, 9703703399,",
//       marginLeft,
//       pageHeight - 20
//     );
//     doc.text(
//       "E-Mail ID: compliance@bnrsecurities.com, investorgrievances@bnrsecurities.com",
//       marginLeft,
//       pageHeight - 15
//     );
//     doc.text(
//       "Error or Discrepancy, if any, in the above statement should be reported to us within 30 days from the date of Receipt.",
//       marginLeft,
//       pageHeight - 10
//     );
//   };

//   // Table Column Alignment based on Data Type
//   const columnStyles = {};
//   tableBody[0]?.forEach((value, index) => {
//     columnStyles[index] = {
//       halign: typeof value === "number" ? "right" : +value ? "right" : "left", // Numbers = Right, Strings = Left
//     };
//   });

//   // Add Table
//   autoTable(doc, {
//     startY: marginTop,
//     head: [tableHeaders],
//     body: tableBody,
//     theme: "grid",
//     margin: { left: 5, right: 5, top: marginTop, bottom: marginBottom + 5 },

//     styles: {
//       fontSize: 6,
//       halign: "right",
//       valign: "middle",
//       fillColor: [235, 236, 238],
//       textColor: [0, 0, 0],
//       lineColor: [255, 255, 255], // Set the border color to white
//       lineWidth: 0.1, // Ensure thin border visibility
//     },

//     columnStyles,

//     headStyles: {
//       fillColor: [18, 97, 166],
//       textColor: 255,
//       fontStyle: "bold",
//       fontSize: 6,
//       halign: "center", // Centers text horizontally
//       valign: "middle", // Centers text vertically
//       lineWidth: 0.1,
//       lineColor: [255, 255, 255],
//     },

//     alternateRowStyles: {
//       fillColor: [245, 246, 248],
//     },

//     didDrawPage: function (data) {
//       header();
//       footer();

//       doc.setFontSize(12);
//       doc.setFont("helvetica", "bold"); // Set font to Helvetica Bold
//       doc.setTextColor(81, 92, 101);
//       doc.text(`${date}`, pageWidth / 2, data.settings.margin.top - 8, {
//         align: "center",
//       });
//     },
//   });
//   const pdf = new jsPDF("p", "mm", "a4");
//   // pdf.save(`${pdfTitle}.pdf`);
//   window.open(doc.output("bloburl"), "_blank");
// };

// export default exportToPDF;

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import bnr_logo from "../../assets/images/bnr_logo.png";

const exportToPDF = (
  pdfTitle,
  userAccountInfo,
  exchange,
  date,
  tableHeaders,
  tableBody,
  tableHeader2,
  tableBody2,
  table2name,
  table1name,
  expenseTable
) => {
  const doc = new jsPDF();

  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;
  const marginLeft = 5;
  const marginRight = 5;
  const marginTop = 70;
  const marginBottom = 30;
  const colWidth = (pageWidth - marginLeft - marginRight) / 2;
  let isTable1Rendered = false;

  const tableExpanseData = Array.isArray(expenseTable)
    ? expenseTable.map(({ label, key }, index) => [`${index + 1}.`, label, key])
    : [];

  // Header Function
  const header = () => {
    doc.setFontSize(9);
    doc.addImage(bnr_logo, "PNG", marginLeft, 10, 0, 15);
    doc.setTextColor(81, 92, 101);
    doc.text("6-3-652, 4TH FLOOR KAUTILYA AMRUTHA ESTATES,", marginLeft, 30);
    doc.text(
      "SOMAJIGUDA HYDERABAD-500082 Ph. No. :40527777-40727777,",
      marginLeft,
      35
    );

    doc.setFillColor(18, 97, 166);
    doc.setTextColor(255, 255, 255);
    doc.rect(marginLeft, 38, colWidth, 12, "F");
    doc.setFont("helvetica", "bold"); // Set font to Helvetica Bold
    doc.setFontSize(14);
    doc.text(pdfTitle, marginLeft + 2, 45);

    doc.setTextColor(81, 92, 101);
    doc.setFontSize(9);
    const pageCount = doc.internal.getNumberOfPages();
    doc.text(`Page ${pageCount}`, pageWidth - marginRight - 15, 15);

    doc.setFillColor(245, 246, 248);
    doc.rect(
      pageWidth - colWidth - marginRight + 10,
      20,
      colWidth - 10,
      30,
      "F"
    );
    doc.setTextColor(81, 92, 101);
    doc.setFontSize(7);
    doc.text(`Account Name:`, pageWidth - colWidth - marginRight + 15, 24);
    doc.setFont("helvetica", "normal");
    doc.text(
      `${userAccountInfo?.name}`,
      pageWidth - colWidth - marginRight + 34,
      24
    );
    doc.setFont("helvetica", "bold");
    doc.text(`Client ID:`, pageWidth - colWidth - marginRight + 15, 28);
    doc.setFont("helvetica", "normal");
    doc.text(
      `${userAccountInfo?.trade?.short_code}`,
      pageWidth - colWidth - marginRight + 27,
      28
    );
    doc.setFont("helvetica", "bold");
    doc.text(`Address:`, pageWidth - colWidth - marginRight + 15, 32);
    doc.setFont("helvetica", "normal");
    doc.text(
      `${userAccountInfo?.personal_details?.address?.line_one}`,
      pageWidth - colWidth - marginRight + 27,
      32
    );
    doc.text(
      `${userAccountInfo?.personal_details?.address?.line_two}`,
      pageWidth - colWidth - marginRight + 27,
      36
    );
    doc.text(
      `${userAccountInfo?.personal_details?.address?.line_three}`,
      pageWidth - colWidth - marginRight + 27,
      40
    );
    doc.text(
      `${userAccountInfo?.personal_details?.address?.line_four}`,
      pageWidth - colWidth - marginRight + 27,
      44
    );
    if (exchange && exchange?.trim() !== "") {
      doc.setFont("helvetica", "bold");
      doc.text(`Exchange:`, pageWidth - colWidth - marginRight + 15, 48);
      doc.setFont("helvetica", "normal");
      doc.text(`${exchange}`, pageWidth - colWidth - marginRight + 28, 48);
    }
  };

  // Footer Function
  const footer = () => {
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(111, 121, 130);
    doc.text(
      "Your running account authorization would continue until it is revoked by you.",
      marginLeft,
      pageHeight - 25
    );

    doc.text(
      "COMPLIANCE OFFICER DETAILS: G SABITHA REDDY, Phone No: 040-40526277, 9703703399,",
      marginLeft,
      pageHeight - 20
    );
    doc.text(
      "E-Mail ID: compliance@bnrsecurities.com, investorgrievances@bnrsecurities.com",
      marginLeft,
      pageHeight - 15
    );
    doc.text(
      "Error or Discrepancy, if any, in the above statement should be reported to us within 30 days from the date of Receipt.",
      marginLeft,
      pageHeight - 10
    );
  };

  // Table Column Alignment based on Data Type
  const columnStyles = {};
  tableBody[0]?.forEach((value, index) => {
    columnStyles[index] = {
      halign: !isNaN(value) && value !== "" ? "right" : "left",
    };
  });

  // Add Table
  const hasValidData = (body) => {
    if (!Array.isArray(body) || body.length === 0) return false;

    const meaningfulRows = body.filter((row) => {
      const isTotalRow = row[0] === "TOTAL";
      if (isTotalRow) return false;

      // Check if at least one value in the row is not empty or not "0.00"
      return row.some((cell) => cell !== "" && cell !== "0.00" && cell !== 0);
    });

    return meaningfulRows.length > 0;
  };

  if (hasValidData(tableBody)) {
    autoTable(doc, {
      startY: table1name === "Realised Gain & Loss" ? marginTop + 5 : marginTop,
      head: [tableHeaders],
      body: tableBody,
      theme: "grid",
      margin: { left: 5, right: 5, top: marginTop, bottom: marginBottom + 5 },

      styles: {
        fontSize: 6,
        halign: "right",
        valign: "middle",
        fillColor: [235, 236, 238],
        textColor: [0, 0, 0],
        lineColor: [255, 255, 255],
        lineWidth: 0.1,
      },

      columnStyles,

      headStyles: {
        fillColor: [18, 97, 166],
        textColor: 255,
        fontStyle: "bold",
        fontSize: 6,
        // halign: "center",
        valign: "middle",
        lineWidth: 0.1,
        lineColor: [255, 255, 255],
      },

      alternateRowStyles: {
        fillColor: [245, 246, 248],
      },
      willDrawCell: function (data) {
        // Apply columnStyles to header cells as well
        if (
          data.section === "head" &&
          typeof columnStyles[data.column.index] !== "undefined"
        ) {
          data.cell.styles.halign = columnStyles[data.column.index].halign;
        }
      },

      didParseCell: function (data) {
        if (
          data.row.index === tableBody.length - 1 &&
          tableBody[tableBody.length - 1][0] === "TOTAL"
        ) {
          // Style last row with custom background and alignment
          data.cell.styles.fillColor = [15, 166, 123]; // Green background
          data.cell.styles.textColor = [255, 255, 255]; // White text
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.halign = "right"; // Align text to the right
        }
      },

      didDrawPage: function (data) {
        header();
        footer();

        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(81, 92, 101);
        doc.text(`${date}`, pageWidth / 2, data.settings.margin.top - 8, {
          align: "center",
        });
        if (data.pageNumber === 1 && table1name === "Realised Gain & Loss") {
          doc.text(`${table1name}`, marginLeft, 68);
        }
      },
    });
    isTable1Rendered = true;
  }

  // Add second table starting a bit below the first one
  if (hasValidData(tableBody2)) {
    let startY = marginTop + 5;
  let availableSpace = pageHeight - marginBottom - marginTop;
  let isOnNewPage = false;
  
  // If first table was rendered, calculate space needed and current position
  if (isTable1Rendered && table2name && table2name.trim() !== "") {
    const currentY = doc.lastAutoTable?.finalY || marginTop;
    const estimatedTable2Height = (tableBody2.length + 1) * 8 + 20; // Rough estimate
    availableSpace = pageHeight - marginBottom - currentY;
    
    if (availableSpace < estimatedTable2Height) {
      doc.addPage();
      startY = marginTop + 5;
      isOnNewPage = true;
    } else {
      startY = currentY + 10; // Add some spacing below first table
      // Add table heading when on same page
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(81, 92, 101);
      doc.text(`${table2name}`, marginLeft, startY - 2);
      startY += 8; // Add space for the heading
    }
  }
    
    autoTable(doc, {
      startY: startY -5 , // Reset startY since it's a new page
      head: [tableHeader2],
      body: tableBody2,
      theme: "grid",
      margin: {
        left: marginLeft,
        right: marginRight,
        top: marginTop,
        bottom: marginBottom,
      },
      styles: {
        fontSize: 6,
        halign: "right",
        valign: "middle",
        fillColor: [235, 236, 238],
        textColor: [0, 0, 0],
        lineColor: [255, 255, 255],
        lineWidth: 0.1,
        letterSpacing: -2,
      },

      columnStyles,

      headStyles: {
        fillColor: [18, 97, 166],
        textColor: 255,
        fontStyle: "bold",
        fontSize: 6,
        // halign: "center",

        valign: "middle",
        lineWidth: 0.1,
        letterSpacing: -2,
        lineColor: [255, 255, 255],
      },

      alternateRowStyles: {
        fillColor: [245, 246, 248],
      },

      didParseCell: function (data) {
        if (
          data.row.index === tableBody2.length - 1 &&
          tableBody2[tableBody2.length - 1][0] === "Total"
        ) {
          data.cell.styles.fillColor = [15, 166, 123]; // Green background
          data.cell.styles.textColor = [255, 255, 255]; // White text
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.halign = "right";
        }
      },
     didDrawPage: function (data) {
  if (data.pageNumber !== 1 || isOnNewPage) {
    header();
    footer();
  }

  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(81, 92, 101);
  doc.text(`${date}`, pageWidth / 2, 62, { align: "center" });

  if (data.pageNumber === 1 && isOnNewPage) {
    doc.text(`${table2name}`, marginLeft, 68);
  }
}
    });

    // Add spacing before Expense Details

    // Add Expense Details table
   
  }
  if (tableExpanseData?.length > 0) {
    let startY = marginTop + 5;
  let needsNewPage = false;
  
  if (hasValidData(tableBody2) || isTable1Rendered) {
    const currentY = doc.lastAutoTable?.finalY || marginTop;
    const estimatedExpenseHeight = (tableExpanseData.length + 1) * 8 + 20; // Rough estimate
    const availableSpace = pageHeight - marginBottom - currentY;
    
    if (availableSpace < estimatedExpenseHeight) {
      doc.addPage();
      needsNewPage = true;
      startY = marginTop + 5;
    } else {
      startY = currentY + 10; // Add some spacing below previous table
    }
  } else {
    // If no tables rendered before, start on same page with margin
    needsNewPage = true;
  }
  
  // Only add header/footer if new page or no previous tables
  if (needsNewPage) {
    header();
    footer();
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(81, 92, 101);
    doc.text(`${date}`, pageWidth / 2, marginTop - 8, {
      align: "center",
    });
    doc.text("Expense Details", marginLeft, 68);
  }
    autoTable(doc, {
      startY: startY,
      head: [["S.No", "Particulars", "Amount"]],
      body: tableExpanseData,
      theme: "grid",
      styles: {
        fontSize: 6,
        halign: "left",
        valign: "middle",
        fillColor: [235, 236, 238],
        textColor: [0, 0, 0],
        lineColor: [255, 255, 255],
        lineWidth: 0.1,
      },
      headStyles: {
        fillColor: [18, 97, 166],
        textColor: 255,
        fontStyle: "bold",
        fontSize: 6,
        valign: "middle",
        lineWidth: 0.1,
        lineColor: [255, 255, 255],
      },
      alternateRowStyles: {
        fillColor: [245, 246, 248],
      },
      margin: {
        left: marginLeft,
        right: marginRight,
        top: marginTop,
        bottom: marginBottom,
      },
      columnStyles: {
        2: { halign: "right" }, // Amount column
      },
      willDrawCell: function (data) {
        if (data.section === "head" && data.column.index === 2) {
          data.cell.styles.halign = "right";
        }
      },
      didDrawPage: function (data) {
        header();
        footer();
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(81, 92, 101);
        doc.text(`${date}`, pageWidth / 2, data.settings.margin.top - 8, {
          align: "center",
        });
        doc.text("Expense Details", marginLeft, 68);
      },
    });
  }

  window.open(doc.output("bloburl"), "_blank");
};

export default exportToPDF;

// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import bnr_logo from "../../assets/images/bnr_logo.png";

// const exportToPDF = (
//   pdfTitle,
//   userAccountInfo,
//   exchange,
//   date,
//   tableHeaders,
//   tableBody,
//   table2Title,
//   table2Headers,
//   table2Body
// ) => {
//   const doc = new jsPDF();

//   const pageWidth = doc.internal.pageSize.width;
//   const pageHeight = doc.internal.pageSize.height;
//   const marginLeft = 5;
//   const marginRight = 5;
//   const marginTop = 70; // Space for first table
//   const marginBottom = 30;
//   const colWidth = (pageWidth - marginLeft - marginRight) / 2;

//   // 🟢 HEADER FUNCTION (No changes)
//   const header = () => {
//     doc.setFontSize(9);
//     doc.addImage(bnr_logo, "PNG", marginLeft, 10, 0, 15);
//     doc.setTextColor(81, 92, 101);
//     doc.text("6-3-652, 4TH FLOOR KAUTILYA AMRUTHA ESTATES,", marginLeft, 30);
//     doc.text(
//       "SOMAJIGUDA HYDERABAD-500082 Ph. No. :40527777-40727777,",
//       marginLeft,
//       35
//     );

//     doc.setFillColor(18, 97, 166);
//     doc.setTextColor(255, 255, 255);
//     doc.rect(marginLeft, 38, colWidth, 12, "F");
//     doc.setFont("helvetica", "bold"); // Set font to Helvetica Bold
//     doc.setFontSize(14);
//     doc.text(pdfTitle, marginLeft + 2, 45);

//     doc.setTextColor(81, 92, 101);
//     doc.setFontSize(9);
//     const pageCount = doc.internal.getNumberOfPages();
//     doc.text(`Page ${pageCount}`, pageWidth - marginRight - 15, 15);

//     doc.setFillColor(245, 246, 248);
//     doc.rect(
//       pageWidth - colWidth - marginRight + 10,
//       20,
//       colWidth - 10,
//       30,
//       "F"
//     );
//     doc.setTextColor(81, 92, 101);
//     doc.setFontSize(7);
//     doc.text(`Account Name:`, pageWidth - colWidth - marginRight + 15, 24);
//     doc.setFont("helvetica", "normal");
//     doc.text(
//       `${userAccountInfo?.name}`,
//       pageWidth - colWidth - marginRight + 34,
//       24
//     );
//     doc.setFont("helvetica", "bold");
//     doc.text(`Client ID:`, pageWidth - colWidth - marginRight + 15, 28);
//     doc.setFont("helvetica", "normal");
//     doc.text(
//       `${userAccountInfo?.trade?.client_id}`,
//       pageWidth - colWidth - marginRight + 27,
//       28
//     );
//     doc.setFont("helvetica", "bold");
//     doc.text(`Address:`, pageWidth - colWidth - marginRight + 15, 32);
//     doc.setFont("helvetica", "normal");
//     doc.text(
//       `${userAccountInfo?.personal_details?.address?.line_one}`,
//       pageWidth - colWidth - marginRight + 27,
//       32
//     );
//     doc.text(
//       `${userAccountInfo?.personal_details?.address?.line_two}`,
//       pageWidth - colWidth - marginRight + 27,
//       36
//     );
//     doc.text(
//       `${userAccountInfo?.personal_details?.address?.line_three}`,
//       pageWidth - colWidth - marginRight + 27,
//       40
//     );
//     doc.text(
//       `${userAccountInfo?.personal_details?.address?.line_four}`,
//       pageWidth - colWidth - marginRight + 27,
//       44
//     );
//     if (exchange && exchange?.trim() !== "") {
//       doc.setFont("helvetica", "bold");
//       doc.text(`Exchange:`, pageWidth - colWidth - marginRight + 15, 48);
//       doc.setFont("helvetica", "normal");
//       doc.text(`${exchange}`, pageWidth - colWidth - marginRight + 28, 48);
//     }
//   };

//   // 🟢 FOOTER FUNCTION (No changes)
//   const footer = () => {
//     doc.setFontSize(9);
//     doc.setFont("helvetica", "normal");
//     doc.setTextColor(111, 121, 130);
//     doc.text(
//       "Your running account authorization would continue until it is revoked by you.",
//       marginLeft,
//       pageHeight - 25
//     );

//     doc.text(
//       "COMPLIANCE OFFICER DETAILS: G SABITHA REDDY, Phone No: 040-40526277, 9703703399,",
//       marginLeft,
//       pageHeight - 20
//     );
//     doc.text(
//       "E-Mail ID: compliance@bnrsecurities.com, investorgrievances@bnrsecurities.com",
//       marginLeft,
//       pageHeight - 15
//     );
//     doc.text(
//       "Error or Discrepancy, if any, in the above statement should be reported to us within 30 days from the date of Receipt.",
//       marginLeft,
//       pageHeight - 10
//     );
//   };

//   // 🟢 FIRST TABLE
//   autoTable(doc, {
//     startY: marginTop,
//     head: [tableHeaders],
//     body: tableBody,
//     theme: "grid",
//     margin: { left: marginLeft, right: marginRight },
//     styles: { fontSize: 6, halign: "right" },
//     headStyles: { fillColor: [18, 97, 166], textColor: 255, fontStyle: "bold" },
//     didDrawPage: function (data) {
//       header();
//       footer();
//       doc.setFontSize(12);
//             doc.setFont("helvetica", "bold");
//             doc.setTextColor(81, 92, 101);
//             doc.text(`${date}`, pageWidth / 2, data.settings.margin.top - 8, {
//               align: "center",
//             });
//     },
//   });

//   // Ensure `table1EndY` is properly calculated
//   let table1EndY = marginTop;
//   if (doc.autoTable && doc.autoTable.previous) {
//     table1EndY = doc.autoTable.previous.finalY + 10; // Space after Table 1
//   }

//   // 🟢 CHECK IF TABLE 2 FITS OR ADD NEW PAGE
//   if (table1EndY + 40 > pageHeight - marginBottom) {
//     doc.addPage();
//     header();
//     table1EndY = marginTop; // Reset position on new page
//   }

//   // 🟢 ADD TABLE 2 TITLE
//   doc.setFontSize(10);
//   doc.setFont("helvetica", "bold");
//   doc.text(table2Title, marginLeft, table1EndY);

//   // 🟢 SECOND TABLE
//   autoTable(doc, {
//     startY: table1EndY + 5,
//     head: [table2Headers],
//     body: table2Body,
//     theme: "grid",
//     margin: { left: marginLeft, right: marginRight },
//     styles: { fontSize: 6, halign: "right" },
//     headStyles: { fillColor: [18, 97, 166], textColor: 255, fontStyle: "bold" },
//     didDrawPage: function () {
//       header();
//       footer();
//     },
//   });

//   window.open(doc.output("bloburl"), "_blank");
// };

// export default exportToPDF;
